
export default function Reviews() {
  const reviews = [
    {
      name: 'Ing. Carlos Mendoza',
      business: 'Planta Manufacturera Grupo Vitro',
      sector: 'Industria Manufacturera',
      rating: 5,
      comment: 'Excelente servicio y productos de alta calidad. Su capacidad de respuesta y cumplimiento en tiempos de entrega ha sido clave para mantener nuestras operaciones sin interrupciones.',
      date: 'Hace 2 meses',
      icon: 'ri-building-2-line'
    },
    {
      name: 'Lic. Patricia Flores',
      business: 'Hotel Fiesta Americana Aguascalientes',
      sector: 'Sector Hotelero',
      rating: 5,
      comment: 'Proveedor confiable para nuestro negocio. Llevamos más de 3 años trabajando con HIPERCLEAN y siempre han cumplido con los estándares de calidad que exige nuestra cadena hotelera.',
      date: 'Hace 1 mes',
      icon: 'ri-hotel-line'
    },
    {
      name: 'Dr. Alejandro Ruiz',
      business: 'Clínica Médica del Centro',
      sector: 'Sector Salud',
      rating: 5,
      comment: 'Atención rápida y profesional. Sus productos de sanitización y químicos especializados cumplen con todas las normas sanitarias requeridas para nuestra clínica. Totalmente recomendados.',
      date: 'Hace 3 semanas',
      icon: 'ri-hospital-line'
    },
    {
      name: 'Mtro. Roberto Sánchez',
      business: 'Corporativo Empresarial del Bajío',
      sector: 'Oficinas Corporativas',
      rating: 5,
      comment: 'Desde que contratamos sus servicios de suministro continuo, hemos reducido costos operativos y mejorado la gestión de insumos. Su equipo siempre está disponible para atender nuestras necesidades.',
      date: 'Hace 1 semana',
      icon: 'ri-briefcase-line'
    },
    {
      name: 'Chef Marco Villanueva',
      business: 'Grupo Restaurantero La Hacienda',
      sector: 'Industria Alimenticia',
      rating: 5,
      comment: 'Los productos cumplen con las normas de higiene alimentaria. Su asesoría técnica nos ayudó a seleccionar los químicos correctos para nuestras cocinas industriales. Servicio de primer nivel.',
      date: 'Hace 2 semanas',
      icon: 'ri-restaurant-line'
    },
    {
      name: 'C.P. Diana Torres',
      business: 'Dependencia Municipal de Aguascalientes',
      sector: 'Sector Gubernamental',
      rating: 4,
      comment: 'Proceso de licitación transparente y cumplimiento total en los contratos de suministro. Productos de calidad certificada y entregas puntuales. Un proveedor serio y formal.',
      date: 'Hace 1 mes',
      icon: 'ri-government-line'
    }
  ];

  return (
    <section id="opiniones" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-20">
          <span className="inline-block text-xs font-semibold tracking-widest text-royal-600 uppercase mb-4">Prueba Social</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Lo que dicen nuestros<br />
            <span className="text-royal-600">clientes empresariales</span>
          </h2>
          <div className="w-16 h-0.5 bg-royal-600 mx-auto mb-8"></div>

          {/* Rating Badge */}
          <div className="inline-flex items-center gap-6 bg-gray-50 border border-gray-200 rounded-2xl px-10 py-6">
            <div className="text-center">
              <div className="text-5xl font-bold text-gray-900 leading-none">4.8</div>
              <div className="text-xs text-gray-500 mt-1 font-medium">de 5 estrellas</div>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-left">
              <div className="flex items-center gap-1 mb-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`text-xl ${i < 4 ? 'ri-star-fill text-yellow-400' : 'ri-star-half-fill text-yellow-400'}`}></i>
                ))}
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-google-fill text-gray-500 text-base"></i>
                </div>
                <span className="text-sm text-gray-600 font-medium">6 opiniones en Google</span>
              </div>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="group bg-white border border-gray-100 rounded-2xl p-7 hover:shadow-xl hover:border-royal-100 transition-all duration-300"
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`text-sm ${i < review.rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'}`}></i>
                ))}
                <span className="ml-auto text-xs text-gray-400 font-medium">{review.date}</span>
              </div>

              {/* Comment */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">
                "{review.comment}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-5 border-t border-gray-100">
                <div className="w-10 h-10 flex items-center justify-center bg-royal-50 rounded-full flex-shrink-0">
                  <i className={`${review.icon} text-royal-600 text-base`}></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{review.name}</div>
                  <div className="text-xs text-gray-500">{review.business}</div>
                </div>
                <span className="ml-auto text-xs font-medium text-royal-600 bg-royal-50 px-2 py-1 rounded-full whitespace-nowrap">
                  {review.sector}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-500 text-sm mb-4">¿Ya trabajaste con nosotros? Comparte tu experiencia</p>
          <a
            href="https://g.page/r/YOUR_GOOGLE_BUSINESS_ID/review"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:border-royal-600 hover:text-royal-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-google-fill text-sm"></i>
            </div>
            Dejar una reseña en Google
          </a>
        </div>
      </div>
    </section>
  );
}
